"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreNav2Menu = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const lib_1 = require("../../lib");
function StoreNav2Menu() {
    const [, dispatch] = (0, lib_1.useUi)();
    return ((0, jsx_runtime_1.jsx)(ui_1.Button, Object.assign({ kind: ['icon', 'transparent'], onClick: () => dispatch('TOGGLE_ECOM_MENU_PANEL') }, { children: (0, jsx_runtime_1.jsx)(svg_1.SvgMenu, {}) })));
}
exports.StoreNav2Menu = StoreNav2Menu;
